import React from "react";
import axios from "axios";


const IS_DEV = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV === "DEV" : process.env.NODE_ENV === "development";

export const API_URL = IS_DEV
    ? process.env.REACT_APP_API_URL_DEV
    : process.env.REACT_APP_API_URL_PROD;

export const DOCUMENT_URL = IS_DEV
    ? process.env.REACT_APP_DOCUMENT_URL_DEV
    : process.env.REACT_APP_DOCUMENT_URL_PROD;

axios.defaults.baseURL = API_URL;

export function sendAnmolOTP(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post('/anmol/user/sendOTP', data)
}

export function userLogout(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post('/portal/user/logout', data)
}
export function validateVendor(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post('/anmol/user/validate', data)
}
export function validateCust(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post('/anmol/user/fetch/ap', data)
}
export function validateEmailMobile(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/user/sendOTP`, data)
}
export function authenticateVendor(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/user/authenticate`, data)
}
export function saveVendorForm1(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/create/web/vendor/form1`, data)
}
export function forgotPasswordOTP(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/forgotpass/send/otp`, data)
}
export function forgotPasswordValidateOTP(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/forgotpass/validate/otp`, data)
}

export function forgotPasswordSet(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/forgotpass/set/password`, data)
}

export function saveVendorPortalForm1(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/create/web/vendor/form1`, data)
}

export function saveCustomerPortalForm1(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/create/web/customer/form1`, data)
}

export function fetchMaterialTypes() {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/fetch/material/type`)
}

export function fetchMaterialBelongsTo(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/fetch/belongsto/bymaterial/type`, data)
}

export function fetchDashboard(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/fetch/dashboard/data`, data)
}

export function updateCustomerPortalForm1(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/update/web/customer/form1`, data)
}

export function showLoginHistory(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/fetch/login/history`, data)
}

export function updateCustomerPortalUploads(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
    return axios.post(`/update/web/customer/uploads`, data)
}

export function updateVendorPortalForm1(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/update/web/vendor/form1`, data)
}
export function updateVendorPortalForm1Rework(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/update/web/vendor/form1/rework`, data)
}

export function fetchApproverDetails(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/fetch/approver/details/empcode`, data)
}


export function saveVendorFormUploads(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
    return axios.post("/create/web/vendor/uploads", data)
}

export function fetchEditable(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post("/fetch/editable/details", data)
}

export function saveEditable(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post("/create/editable/details", data)
}

export function saveCustomerFormUploads(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
    return axios.post("/create/web/customer/uploads", data)
}
export function updateVendorFormUploads(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
    return axios.post("/update/web/vendor/uploads", data)
}
export function updateVendorFormUploadsRework(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
    return axios.post("/update/web/vendor/uploads/rework", data)
}

export function userLogin(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/portal/user/authenticate`, data)
}

export function createMaterial(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/create/material`, data)
}

export function fetchMaterials(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/fetch/material`, data)
}

export function changePassword(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/change/password`, data)
}


export function approveMaterial(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/approve/material`, data)
}

export function approveVendor(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/approve/vendor`, data)
}

export function createUser(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/create/new/portal/user`, data)
}
export function saveApprovalMatrix(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/set/material/approval/matrix`, data)
}

export function fetchAuditLog(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/fetch/audit/logs`, data)
}

export function fetchSingleMaterial(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/fetch/material/byid`, data)
}


export function getAllUsers(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/getall/portal/user`, data)
}
export function fetchAllVendors(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/getall/vendor`, data)
}

export function saveApprovalApprovalMatrixVendor(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/set/vendor/approval/matrix`, data)
}

export function saveApprovalMatrixCustomer(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/set/customer/approval/matrix`, data)
}

export function fetchVendorMatrix(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/get/vendor/approval/matrix`,data)
}

export function fetchCustomerMatrix(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/get/customer/approval/matrix`,data)
}

export function fetchAllCustomer(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/getall/customer`,data)
}

export function fetchMaterialMatrix(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/get/material/approval/matrix`, data)
}

export function fetchRoleMaster(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/fetch/rolemaster`,data)
}

export function fetchCustomerByCode(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/get/customer/bysapcode`,data)
}
export function createRoleMaster(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/create/rolemaster`,data)
}

export function updateVendorMDM(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/update/web/vendor/mdm`,data)
}
export function updateCustomerMDM(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/update/web/customer/mdm`,data)
}
export function syncVendorMDM(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/sync/mdm/vendor/insap`,data)
}

export function syncCustomerMDM(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/sync/mdm/customer/insap`,data)
}

export function submitCustomerApproval(data) {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/approve/customer`,data)
}

export function vendorUpdateOtp(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/vendor/update/user/sendOTP`, data)
}
export function customerUpdateOtp(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/customer/update/user/sendOTP`, data)
}

export function vendorUpdateOtpValidation(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/vendor/update/user/authenticate`, data)
}

export function customerUpdateOtpValidation(data) {
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/customer/update/user/authenticate`, data)
}

export function fetchKDSMaterial() {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/mdm/fetch/material/kds`)
}

export function fetchKDSCustomer() {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/mdm/fetch/customer/kds`)
}

export function fetchKDSVendor() {
    let token = localStorage.getItem("userToken");
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    axios.defaults.headers.post["Content-Type"] = "application/json";
    return axios.post(`/mdm/fetch/vendor/kds`)
}